import React, { FC } from 'react';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';
import { PriceMainProps } from 'common/components/product-price-view/types';
import { getIsUnavailable, getPrimaryPrice } from 'features/product-info/ducks/selectors';
import { getGoodsSupplyCase, getGoodsSupplyData, GoodsSupplyCase } from 'features/goods-supply';
import { FirstPriceView } from '../pdp-price-view';
import { price as priceStyle } from './styles';

type Props = {
  isUnavailable: boolean;
  price: PriceMainProps;
  supplyCase: GoodsSupplyCase | null;
  isSupplyDataLoaded?: boolean;
};

const OutOfStockPrice: FC<Props> = ({ isUnavailable, price, supplyCase, isSupplyDataLoaded }) => {
  const isPriceAvailable =
    isUnavailable || (isSupplyDataLoaded && (supplyCase === 'CASE_2' || supplyCase === null));

  if (isPriceAvailable) {
    return <FirstPriceView price={price} className={priceStyle} />;
  }
};

const mapStoreToProps = (store: RootReducer): Props => {
  const firstPrice = getPrimaryPrice(store) as PriceMainProps;
  const isUnavailable = getIsUnavailable(store);
  const supplyCase = getGoodsSupplyCase(store);
  const supplyData = getGoodsSupplyData(store);
  return {
    price: firstPrice,
    isUnavailable,
    supplyCase,
    isSupplyDataLoaded: !!supplyData,
  };
};

export const PdpOutOfStockPrice = connect(mapStoreToProps, null, (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
}))(OutOfStockPrice);
